module.exports = __webpack_public_path__ + "static/img/ranking-bg.e2c774f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rankingimg/ranking-bg.png
// module id = DWlg
// module chunks = 1